module.exports = __webpack_public_path__ + "static/media/check.eda1f2a0.svg";